// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var titleBlockStyles = css({
  justifyContent: 'center',
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  marginTop: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var mainTextStyles = css({
  display: 'inline',
  justifyContent: 'center',
  marginTop: "var(--ds-space-0, 0px)",
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var connectButtonStyles = css({
  justifyContent: 'center',
  marginTop: "var(--ds-space-100, 8px)"
});